import { render, staticRenderFns } from "./NoName.vue?vue&type=template&id=5404e5de&"
import script from "./NoName.vue?vue&type=script&lang=js&"
export * from "./NoName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports